<template>
<div class="container">
  <div class="row">
      <div class="col-lg-12">
          <div class="list__title">
                  <h2>Danh sách đấu giá viên</h2>
          </div>
      </div>
  </div>
  <div class="row">
      <div class="col-lg-12">

          <div class="list__user">
              <div class="user__left">
                  <img src="@/assets/images/quanvanminh.png" alt="">                        
              </div>
              <div class="user__right">
                  <div class="user__name"><h4>Quản Văn Minh</h4></div>
                  <div class="user__info">
                      <span class="user__label user__label--full pd-l">Chứng chỉ hành nghề (Do Bộ Tư pháp cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số chứng chỉ :</span><span class="user__value pd-l">409</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">09/08/2011</span>
                  </div>
                  <div class="user__info">
                      <span class="user__label pd-l user__label--full">Thẻ đấu giá viên (Do Sở Tư pháp Hà Nội cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số thẻ :</span><span class="user__value pd-l">409</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">09/08/2011</span>
                  </div>
                  <div class="user__detail">
                      Ths.Luật sư – Đấu giá viên Quản Văn Minh là Tổng giám đốc Công ty Đấu giá hợp danh 
                      Số 5 – Quốc Gia và đồng thời giữ các chức vụ Ủy viên Ban Thường vụ Trung Ương 
                      Hội Luật gia Việt Nam; Chủ tịch Hội Đấu giá viên thành phố Hà Nội; Thành viên 
                      Đoàn Luật sư thành phố Hà Nội; Phó chủ tịch thường trực Trung tâm trọng tài thương 
                      mại Luật gia Việt Nam; Phó chủ tịch Hội bảo vệ quyền tác phẩm điện ảnh và phim truyền 
                      hình Việt Nam; Thành viên Tổ biên tập Dự án Luật Đấu giá tài sản. Ông Quản Văn Minh đã 
                      có hơn 20 năm kinh nghiệm trong lĩnh vực tư vấn các vấn đề cho doanh nghiệp về Luật 
                      doanh nghiệp, luật lao động, luật bảo vệ môi trường, luật cạnh tranh, chuyển giao quyền 
                      thương mại.
                  </div>
              </div>
          </div>

          <div class="list__user">
              <div class="user__left">
                  <img src="@/assets/images/levietnga.png" alt="">                        
              </div>
              <div class="user__right">
                  <div class="user__name"><h4>Lê Việt Nga</h4></div>
                  <div class="user__info">
                      <span class="user__label user__label--full pd-l">Chứng chỉ hành nghề (Do Bộ Tư pháp cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số chứng chỉ :</span><span class="user__value pd-l">485</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">11/07/2011</span>
                  </div>
                  <div class="user__info">
                      <span class="user__label pd-l user__label--full">Thẻ đấu giá viên (Do Sở Tư pháp Hà Nội cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số thẻ :</span><span class="user__value pd-l">273</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">04/10/2019</span>
                  </div>
                  <div class="user__detail">
                      Ths.Luật sư – Đấu giá viên Lê Việt Nga là Giám đốc điều hành Công ty Đấu giá hợp danh Số 5 – Quốc Gia, đồng thời là Thành viên Đoàn Luật sư thành phố Hà Nội; Trọng tài viên - Tổng thư ký Trung tâm trọng tài thương mại Luật gia Việt Nam Bà Lê Việt Nga đã có gần 15 năm kinh nghiệm và kiến thức chuyên sâu trong các lĩnh vực tư vấn pháp luật về tài chính – kinh doanh thương mại; Thương mại quốc tế, Tư pháp quốc tế, tư vấn đầu tư, tư vấn doanh nghiệp, kinh doanh bất động sản, bán đấu giá tài sản.
                  </div>
              </div>
          </div>

          <div class="list__user">
              <div class="user__left">
                  <img src="@/assets/images/hoangminhduc.png" alt="">                        
              </div>
              <div class="user__right">
                  <div class="user__name"><h4>Hoàng Minh Đức</h4></div>
                  <div class="user__info">
                      <span class="user__label user__label--full pd-l">Chứng chỉ hành nghề (Do Bộ Tư pháp cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số chứng chỉ :</span><span class="user__value pd-l">614</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">11/06/2012</span>
                  </div>
                  <div class="user__info">
                      <span class="user__label pd-l user__label--full">Thẻ đấu giá viên (Do Sở Tư pháp Hà Nội cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số thẻ :</span><span class="user__value pd-l">272</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">10/04/2019</span>
                  </div>
                  <div class="user__detail">
                      Đấu giá viên Hoàng Minh Đức là Phó Giám đốc Công ty Đấu giá hợp danh Số 5 – Quốc Gia. Ông Hoàng Minh Đức đã có 8 năm kinh nghiệm là Đấu giá viên và có 10 năm kinh nghiệm trong lĩnh vực kinh tế, kinh doanh bất động sản và hoạt động đấu giá tài sản. Ông Hoàng Minh Đức có bằng Cử nhân quản trị kinh doanh, Cử nhân Luật
                  </div>
              </div>
          </div>

          <div class="list__user">
              <div class="user__left">
                  <img src="@/assets/images/taothuminhnguyet.png" alt="">                        
              </div>
              <div class="user__right">
                  <div class="user__name"><h4>Tào Thu Minh Nguyệt</h4></div>
                  <div class="user__info">
                      <span class="user__label user__label--full pd-l">Chứng chỉ hành nghề (Do Bộ Tư pháp cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số chứng chỉ :</span><span class="user__value pd-l">1275</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">04/10/2015</span>
                  </div>
                  <div class="user__info">
                      <span class="user__label pd-l user__label--full">Thẻ đấu giá viên (Do Sở Tư pháp Hà Nội cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số thẻ :</span><span class="user__value pd-l">265</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">04/10/2019</span>
                  </div>
                  <div class="user__detail">
                      Luật sư – Đấu giá viên Tào Thu Minh Nguyệt là Phó Giám đốc Nghiệp vụ Công ty Đấu giá hợp danh Số 5 – Quốc Gia. Bà Tào Thu Minh Nguyệt đã có 5 năm kinh nghiệm là Đấu giá ngoài ra có 10 năm kinh nghiệm trong lĩnh vực tư vấn pháp luật về doanh nghiệp, thương mại, lao động, dân sự, hôn nhân gia đình và hoạt động đấu giá tài sản. Bà Tào Thu Minh Nguyệt có bằng Cử nhân Luật – Chuyên ngành Luật Kinh tế.
                  </div>
              </div>
          </div>

          <div class="list__user">
              <div class="user__left">
                  <img src="@/assets/images/vuvanhue.png" alt="">                        
              </div>
              <div class="user__right">
                  <div class="user__name"><h4>Vũ Văn Huệ</h4></div>
                  <div class="user__info">
                      <span class="user__label user__label--full pd-l">Chứng chỉ hành nghề (Do Bộ Tư pháp cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số chứng chỉ :</span><span class="user__value pd-l">959</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">18/07/2014</span>
                  </div>
                  <div class="user__info">
                      <span class="user__label pd-l user__label--full">Thẻ đấu giá viên (Do Sở Tư pháp Hà Nội cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số thẻ :</span><span class="user__value pd-l">263</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">04/10/2019</span>
                  </div>
                  <div class="user__detail">
                      Ông Vũ Văn Huệ đã có 6 năm kinh nghiệm hành nghề Đấu giá. Ngoài ra còn là Luật sư thành viên Đoàn luật sư TP Hà Nội. Ông Vũ Văn Huệ có nhiều năm kinh nghiệm trong lĩnh vực khoa học hình sự, tư vấn pháp lý và dịch vụ tư vấn pháp luật, từng tham gia trong các vụ án phức tạp và tư vấn pháp lý cho nhiều tổ chức, cá nhân. Ông Vũ Văn Huệ có các chứng chỉ: Chứng chỉ hành nghề luật sư; Chứng chỉ hành nghề đấu giá.
                  </div>
              </div>
          </div>

          <div class="list__user">
              <div class="user__left">
                  <img src="@/assets/images/phamthihoc.png" alt="">                        
              </div>
              <div class="user__right">
                  <div class="user__name"><h4>Phạm Thị Học</h4></div>
                  <div class="user__info">
                      <span class="user__label user__label--full pd-l">Chứng chỉ hành nghề (Do Bộ Tư pháp cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số chứng chỉ :</span><span class="user__value pd-l">486</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">11/07/2011</span>
                  </div>
                  <div class="user__info">
                      <span class="user__label pd-l user__label--full">Thẻ đấu giá viên (Do Sở Tư pháp Hà Nội cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số thẻ :</span><span class="user__value pd-l">262</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">04/10/2019</span>
                  </div>
                  <div class="user__detail">
                      Bà Phạm Thị Học đã có 9 năm kinh nghiệm hành nghề đấu giá. Ngoài ra bà Học còn là Thạc sỹ, Luật sư nguyên là Phó trưởng – Phụ trách Bộ môn Luật Hình sự, Khoa Hình sự, ĐH Luật Hà Nội. Có kiến thức chuyên sâu trong lĩnh vực pháp luật. Bà Phạm Thị Học có các chứng chỉ: Chứng chỉ hành nghề luật sư; Chứng chỉ hành nghề đấu giá.
                  </div>
              </div>
          </div>

          <div class="list__user">
              <div class="user__left">
                  <img src="@/assets/images/nguyenthinu.png" alt="">                        
              </div>
              <div class="user__right">
                  <div class="user__name"><h4>Nguyễn Thị Nụ</h4></div>
                  <div class="user__info">
                      <span class="user__label user__label--full pd-l">Chứng chỉ hành nghề (Do Bộ Tư pháp cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số chứng chỉ :</span><span class="user__value pd-l">1985</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">01/03/2018</span>
                  </div>
                  <div class="user__info">
                      <span class="user__label pd-l user__label--full">Thẻ đấu giá viên (Do Sở Tư pháp Hà Nội cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số thẻ :</span><span class="user__value pd-l">264</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">04/10/2019</span>
                  </div>
                  <div class="user__detail">
                      Bà Nguyễn Thị Nụ là Đấu giá viên đã có 3 năm kinh nghiệm hành nghề. Ngoài ra còn là Luật sư thành viên Đoàn luật sư TP Hà Nội. Bà Nguyễn Thị Nụ có nhiều năm kinh nghiệm trong lĩnh vực tư vấn pháp luật về doanh nghiệp và hoạt động đấu giá tài sản. Bà Nguyễn Thị Nụ có các chứng chỉ: Chứng chỉ hành nghề luật sư; Chứng chỉ hành nghề đấu giá
                  </div>
              </div>
          </div>

          <div class="list__user">
              <div class="user__left">
                  <img src="@/assets/images/nguyenngocyen.png" alt="">                        
              </div>
              <div class="user__right">
                  <div class="user__name"><h4>Nguyễn Ngọc Yến</h4></div>
                  <div class="user__info">
                      <span class="user__label user__label--full pd-l">Chứng chỉ hành nghề (Do Bộ Tư pháp cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số chứng chỉ :</span><span class="user__value pd-l">1653</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">12/01/2017</span>
                  </div>
                  <div class="user__info">
                      <span class="user__label pd-l user__label--full">Thẻ đấu giá viên (Do Sở Tư pháp Hà Nội cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số thẻ :</span><span class="user__value pd-l">271</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">22/02/2019</span>
                  </div>
                  <div class="user__detail">
                      Bà Nguyễn Ngọc Yến là Đấu giá viên đã có 3 năm kinh nghiệm hành nghề. Ngoài ra còn là Thạc sỹ, Luật sư thành viên Đoàn luật sư TP Hà Nội. Bà Nguyễn Ngọc Yến có nhiều năm kinh nghiệm trong lĩnh vực tư vấn pháp luật về doanh nghiệp và hoạt động đấu giá tài sản. Bà Nguyễn Ngọc Yến có các chứng chỉ: Chứng chỉ hành nghề luật sư; Chứng chỉ hành nghề đấu giá.
                  </div>
              </div>
          </div>

          <div class="list__user">
              <div class="user__left">
                  <img src="@/assets/images/nguyenduchoan.png" alt="">                        
              </div>
              <div class="user__right">
                  <div class="user__name"><h4>Nguyễn Đức Hoàn</h4></div>
                  <div class="user__info">
                      <span class="user__label user__label--full pd-l">Chứng chỉ hành nghề (Do Bộ Tư pháp cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số chứng chỉ :</span><span class="user__value pd-l">1984</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">30/06/2017</span>
                  </div>
                  <div class="user__info">
                      <span class="user__label pd-l user__label--full">Thẻ đấu giá viên (Do Sở Tư pháp Hà Nội cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số thẻ :</span><span class="user__value pd-l">261</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">04/10/2019</span>
                  </div>
                  <div class="user__detail">
                      Ông Nguyễn Đức Hoàn là Đấu giá viên đã có 3 năm kinh nghiệm hành nghề. Ngoài ra còn là Luật sư thành viên Đoàn luật sư TP Hà Nội. Ông Nguyễn Đức Hoàn có nhiều năm kinh nghiệm trong lĩnh vực tư vấn pháp luật, đặc biệt là trong lĩnh vực Ngân hàng. Ông Nguyễn Đức Hoàn có các chứng chỉ: Chứng chỉ hành nghề luật sư; Chứng chỉ hành nghề đấu giá.
                  </div>
              </div>
          </div>

          <div class="list__user">
              <div class="user__left">
                  <img src="@/assets/images/Nguyenduchiet.png" alt="">                        
              </div>
              <div class="user__right">
                  <div class="user__name"><h4>Nguyễn Đức Hiệt</h4></div>
                  <div class="user__info">
                      <span class="user__label user__label--full pd-l">Chứng chỉ hành nghề (Do Bộ Tư pháp cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số chứng chỉ :</span><span class="user__value pd-l">1438</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">04/10/2018</span>
                  </div>
                  <div class="user__info">
                      <span class="user__label pd-l user__label--full">Thẻ đấu giá viên (Do Sở Tư pháp Hà Nội cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số thẻ :</span><span class="user__value pd-l">260</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">04/10/2019</span>
                  </div>
                  <div class="user__detail">
                      Ông Nguyễn Đức Hiệt là Đấu giá viên đã có 4 năm kinh nghiệm hành nghề. Ngoài ra còn là Tiến sỹ Luật, đồng thời là Luật sư thành viên Đoàn luật sư TP Hà Nội. Ông Nguyễn Đức Hiệt có nhiều năm kinh nghiệm trong lĩnh vực khoa học hình sự, tư vấn pháp lý và dịch vụ tư vấn pháp luật, từng tham gia trong các vụ án phức tạp và tư vấn pháp lý cho nhiều tổ chức, cá nhân. Ông Nguyễn Đức Hiệt có các chứng chỉ: Chứng chỉ hành nghề luật sư; Chứng chỉ hành nghề đấu giá.
                  </div>
              </div>
          </div>

          <div class="list__user">
              <div class="user__left">
                  <img src="@/assets/images/LuongThiTram.png" alt="">                        
              </div>
              <div class="user__right">
                  <div class="user__name"><h4>Lương Thị Trâm</h4></div>
                  <div class="user__info">
                      <span class="user__label user__label--full pd-l">Chứng chỉ hành nghề (Do Bộ Tư pháp cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số chứng chỉ :</span><span class="user__value pd-l">487</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">11/07/2011</span>
                  </div>
                  <div class="user__info">
                      <span class="user__label pd-l user__label--full">Thẻ đấu giá viên (Do Sở Tư pháp Hà Nội cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số thẻ :</span><span class="user__value pd-l">270</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">04/10/2019</span>
                  </div>
                  <div class="user__detail">
                      Bà Lương Thị Trâm đã có 9 năm kinh nghiệm hành nghề đấu giá và hơn mười năm kinh nghiệm trong lĩnh vực quản lý doanh nghiệp, điều hành hoạt động của doanh nghiệp. Bà Lương Thị Trâm có bằng Cử nhân Luật, Chứng chỉ hành nghề đấu giá.
                  </div>
              </div>
          </div>

          <div class="list__user">
              <div class="user__left">
                  <img src="@/assets/images/CaoDacNhat.png" alt="">                        
              </div>
              <div class="user__right">
                  <div class="user__name"><h4>Cao Đắc Nhật</h4></div>
                  <div class="user__info">
                      <span class="user__label user__label--full pd-l">Chứng chỉ hành nghề (Do Bộ Tư pháp cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số chứng chỉ :</span><span class="user__value pd-l">1274</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">23/12/2015</span>
                  </div>
                  <div class="user__info">
                      <span class="user__label pd-l user__label--full">Thẻ đấu giá viên (Do Sở Tư pháp Hà Nội cấp) :</span>
                      <span class="user__label user__label--m-full pd-m">Số thẻ :</span><span class="user__value pd-l">266</span>
                      <span class="user__label user__label--m-full pd-m">Ngày cấp :</span><span class="user__value">10/04/2019</span>
                  </div>
                  <div class="user__detail">
                      Ông Cao Đắc Nhật đã có 5 năm kinh nghiệm hành nghề đấu giá Ngoài ra còn là Luật sư thành viên Đoàn luật sư TP Hà Nội. Ông Cao Đắc Nhật Có nhiều năm kinh nghiệm trong lĩnh vực tư vấn pháp luật về doanh nghiệp và hoạt động đấu giá tài sản. Ông Cao Đắc Nhật có các chứng chỉ: Chứng chỉ hành nghề luật sư; Chứng chỉ hành nghề đấu giá.
                  </div>
              </div>
          </div>


      </div>
  </div>
</div>
</template>

<script>
import mixin from '@/mixins/mixin.js'
export default {
  name: 'Auctioneers',
  mixins: [mixin],
  data () {
    return {
    }
  },
  methods: {
  },
}
</script>

<style scoped>
table, th, td {
   border: 1px solid #e6e6e6;
} 
td,
th {
    padding: 10px 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Auctioneers.vue